import { Card, CardHeader } from '../../../components/Card.jsx'
import { Tile, RankTable, BarList, MethodNote, fmtNum } from '../ui.jsx'

/**
 * National Disease Burden — the most frequently coded diagnoses across
 * every encounter on the platform in the selected window. Sourced from
 * coded ICD-10 diagnoses; each bucket is k=5 privacy-floor suppressed.
 */
export default function DiseaseBurden({ data, windowDays }) {
  const db = data.disease_burden || {}
  const top = db.top_diagnoses || []
  const barItems = top.slice(0, 10).map((d) => ({ label: `${d.code} · ${d.description}`, count: d.count }))

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader
          title={`National disease burden · last ${windowDays} days`}
          subtitle="Whole-population view: every encounter from every participating user contributes. Aggregate-only, k=5 privacy floor."
          right={
            <span className="text-[10px] uppercase tracking-wide border rounded-full px-2 py-0.5 bg-coral-50 text-coral-700 border-coral-200">
              ICD-10 coded
            </span>
          }
        />
        <MethodNote>
          Counts coded ICD-10 diagnosis events on encounters in the selected
          window, grouped by exact code. A patient seen repeatedly contributes
          each time. Codes with fewer than 5 records are hidden (k=5 floor).
        </MethodNote>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          <Tile label="Coded diagnoses" value={fmtNum(db.total_coded_diagnoses)} colour="wantok" />
          <Tile label="Distinct conditions" value={fmtNum(db.distinct_codes)} colour="sky" />
          <Tile label="In top 20 shown" value={fmtNum(top.length)} colour="slate" />
        </div>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card>
          <CardHeader title="Top diagnoses" subtitle="Ranked by frequency in the window." />
          <RankTable
            rows={top}
            columns={[
              { key: 'code', label: 'Code', width: 'w-24', cellClass: 'font-mono text-wantok-700' },
              { key: 'description', label: 'Description' },
              { key: 'count', label: 'Count', align: 'right', render: (r) => fmtNum(r.count) },
            ]}
          />
        </Card>
        <Card>
          <CardHeader title="Relative load" subtitle="Top 10 conditions, scaled to the most common." />
          <BarList items={barItems} colour="coral" />
        </Card>
      </div>
    </div>
  )
}
